import React, { Component } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import '@ag-grid-community/styles/ag-theme-quartz.css';
import '@ag-grid-community/styles/ag-theme-balham.css';
import '@ag-grid-community/styles/ag-grid.css';
import AgOpenInNewTab from 'Components/AgGridTable/AgGridIcon/AgOpenInNewTab.jsx';
import AgGridButton from 'Components/AgGridTable/AgGridButton/AgGridButton';
import AgGridBookMark from 'Components/AgGridTable/AgGridIcon/AgGridBookMark.jsx';
import AgGridComponentWrapper from 'Components/AgGridTable/AgGridDisplayTypeWrapper/AgGridComponentWrapper.jsx';
import AgGridCheckbox from 'Components/AgGridTable/AgGridCheckbox/AgGridCheckbox.jsx';
import AgGridCheckboxHeader from 'Components/AgGridTable/AgGridCheckboxHeader/AgGridCheckboxHeader.jsx';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import AgTrashIcon from 'Components/AgGridTable/AgGridIcon/AgTrashIcon.jsx';
import AgImageIcon from 'Components/AgGridTable/AgGridIcon/AgImageIcon.jsx';
import AgFolderIcon from 'Components/AgGridTable/AgGridIcon/AgFolderIcon.jsx';
import counterpart from 'counterpart';
import PropTypes from 'prop-types';
import Customtooltip from 'Components/AgGridTable/CustomTooltip/Customtooltip.jsx';
import { getSortArray } from 'Utils/sortArrayUtil.js'
import { AG_GRID_ICONS, AG_GRID_COLUMNS } from '../AgGridTable/AgGridConstant.js';
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';
import { MenuModule } from '@ag-grid-enterprise/menu';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import './AgGridTable.scss';
import { isEqual } from 'Utils/lodashUtils';
import { flushSync } from 'react-dom';
import { COLORS } from "Constants/BIDashboardConstants"

export class AgGridTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resizable: true,
      caseData: {},
      isSortClicked: false,
      isLoading: false,
      sortModel: [],
      gridSortArray: [...this.props.sort],
      isSuccess: true,
      pageNumber: 0,
      acquirerCode: JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode,
      dataLoaded: false,
      isPagable: this.props.isPagable,
      rowModelType: this.props.isPagable ? 'clientSide' : "serverSide",
      cacheOverflowSize: 2,
      maxConcurrentDatasourceRequests: 1,
      infiniteInitialRowCount: 25,
      maxBlocksInCache: 10,
      isTableReady: false,
      isDraggable: false,
      modules: [
        RowGroupingModule,
        ServerSideRowModelModule,
        MenuModule,
        ClientSideRowModelModule,
      ],
      paginationPageSize: 25,
      shouldAutoSize: false,
      tooltipShowDelay: 0,
      components: {},
      context: { componentParent: this },
      defaultColDef: {
        cellStyle: function (params) {
          return {
            "background-color": 'white',
            'fontFamily': 'Roboto, sans-serif',
            'font-size': '13px',
            'color': '#3a3c44',
            'overflow': 'visible',
          };
        },
        cellClass: "locked-col",
        tooltipComponent: "customTooltip",
        cellDataType: false,
      },
      isMerchantPortal: this.props.isMerchantPortal,
      getMerchantActions: this.props.getMerchantActions,
      isColumnChanged: false,
    };
    this.attachBindings();
  };

  attachBindings() {
    this.setColumnConfiguration = this.setColumnConfiguration.bind(this);
    this.gotoExtraCaseDetailsPage = this.gotoExtraCaseDetailsPage.bind(this);
    this.handleServerSideSort = this.handleServerSideSort.bind(this);
    this.autoSizeAllColumns = this.autoSizeAllColumns.bind(this);
    this.onRowSelected = this.onRowSelected.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.getSortOrderAndSortIndex = this.getSortOrderAndSortIndex.bind(this);
  };

  gotoExtraCaseDetailsPage(id) {
    window.open(`#/casedetails/${this.props.caseNumber}?key=${id}`, 'scrollbars=1,toolbar=0,top=0,left=0').resizeTo(screen.width, screen.height);
  };

  UNSAFE_componentWillMount() {
    this.setColumnConfiguration(this.props.columns);
    this.setState({
      animateRows: this.props.animateRows,
      maxBlocksInCache: this.props.maxBlocksInCache,
      cacheBlockSize: this.props.cacheBlockSize,
      suppressRowTransform: this.props.suppressRowTransform,
      autoHeight: this.props.autoHeight,
      rowHeight: this.props.rowHeight,
      suppressPaginationPanel: this.props.suppressPaginationPanel,
      paginationPageSize: this.props.paginationPageSize,
      recordsShown: this.props.recordsShown,
      currentPage: this.props.currentPage,
      isNextPage: this.props.isNextPage,
      newPage: this.props.newPage,
      pageSize: this.props.pageSize,
      rowData: this.props.rowData,
      components: this.props.components,
    })
  };

  componentDidMount() {
    this.setState({
      gridSortArray: [...this.props.sort],
    })
  };

  copyToClipBoard = (event) => {
    const dummy = document.createElement('textarea');
    document.body.appendChild(dummy);
    if (event) {
      dummy.value = event.target.innerText;
    }
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);

  };

  UNSAFE_componentWillReceiveProps(newProps) {
    if (this.props.agLoader != newProps.agLoader) {
      this.setState({
        isLoading: newProps.agLoader,
      })
    }
    if (this.props.selectedRows && newProps.selectedRows && this.props.selectedRows.length != newProps.selectedRows.length) {
      this.setState({
        isDraggable: newProps.selectedRows.length > 0 ? true : false,
      });
    }
    if (this.props.columns && !isEqual(this.props.columns, newProps.columns)) {
      this.setState({ isColumnChanged: true }); 
      this.setColumnConfiguration(newProps.columns); 
    }
    if (this.props.pageSize && this.props.pageSize !== newProps.pageSize) {
      this.setState({
        pageSize: newProps.pageSize,
      });
    }
    if (this.props.newPage && this.props.newPage !== newProps.newPage) {
      this.setState({
        newPage: newProps.newPage,
      });
    }
    if (this.props?.rowData && !isEqual(this.props?.rowData, newProps?.rowData)) {
      this.setState({ rowData: newProps?.rowData, totalRecords: newProps?.totalRecords, totalPages: newProps?.totalPages });
    }
    if (!isEqual(this.props?.sort, newProps?.sort)) {
      this.setColumnConfiguration(newProps.columns);
    }
    if (this.state.isTableReady && this.props.bookMarkedRows && this.props.bookMarkedRows !== newProps.bookMarkedRows) {
      var params = {
        columns: [AG_GRID_ICONS.BOOKMARK_ICON],
        force: true
      };
      this.gridApi.refreshCells(params);
    }
    if (this.state.isTableReady && this.props.selectedRows && this.props.selectedRows !== newProps.selectedRows) {
      var params = {
        columns: [AG_GRID_ICONS.CHECKBOX_ICON],
        force: true
      };
      this.gridApi.refreshCells(params);
    }
    if (this.props.isRefreshed && this.state.isTableReady) {
      this.gridApi.refreshHeader();
    }
    if (!isEqual(this.props.sort, newProps.sort)) {
      this.setState({
        gridSortArray: [...newProps.sort],
      })
    }
  };

  autoSizeAllColumns = (allColumns) => {
    const columnsForAutoResize = allColumns?.filter(col => (col?.groupId || col?.colDef?.groupId) !== 'ICON').map(col => col?.colId);
    this?.gridApi?.autoSizeColumns(columnsForAutoResize, false);
  };

  getSortOrderAndSortIndex = (columnKey) => {
    if (this.state.gridSortArray?.some(ele => ele?.key === columnKey)) {
      return {
        sort: this.state.gridSortArray?.filter(ele => ele?.key === columnKey)[0].order ? 'asc' : 'desc',
        sortIndex: this.state.gridSortArray.findIndex(ele => ele?.key === columnKey)
      };
    }
    return {};
  };

  setColumnConfiguration = (columnList) => {
    if (columnList) {
      var columnDefs = [];
      columnList.forEach((column) => {
        let agGridColumn = {
          field: column.columnKey,
          headerName: column.name,
          sortable: column.isSortable,
          sortingIcon: true,
          suppressMovable: true,
          suppressHeaderMenuButton: true,
          suppressHeaderContextMenu: true,
          suppressHeaderFilterButton: true,
          groupId: column.displayType,
          resizable: true,
          sortingOrder: ["desc", "asc"],
          isNewQueueLanding: this.props.isNewQueueLanding,
          ...(column.isSortable && this.getSortOrderAndSortIndex(column.columnKey)),
          ...({
            comparator: () => {
              return 0;
            }
          })
        }
        agGridColumn = this.setColumnDefination(agGridColumn, column.columnKey);
        columnDefs.push(agGridColumn);
      });
      this.setState({
        columnDefs,
      });

    }
  };

  setColumnDefination = (agGridColumn, type) => {
    let isCellborder = this.props?.isCellborder;
    let isGridCompact = this.props?.isGridCompact;
    let acquirerCode = JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode[0] || "GPN";
    switch (type) {
      case AG_GRID_ICONS.CHECKBOX_ICON:
        agGridColumn.pinned = 'left',
          agGridColumn.width = 60,
          agGridColumn.cellRenderer = "tableCheckbox",
          agGridColumn.headerComponent = "tableHeaderCheckbox";
        agGridColumn.suppressSizeToFit = true,
          agGridColumn.resizable = false,
          agGridColumn.headerName = '',
          agGridColumn.cellStyle = function (params) {
            return {
              'padding-left': '17px',
              'padding-top': '9px',
            }
          }

        break;
      case AG_GRID_ICONS.BOOKMARK_ICON:
        var bookmarkColor = COLORS.oneGp.black;
        if (this.state.acquirerCode.includes('HPY')) {
          bookmarkColor = "#1362E2";
        }
        agGridColumn.pinned = 'left',
          agGridColumn.cellRenderer = "bookmarkView",
          agGridColumn.width = 60,
          agGridColumn.suppressSizeToFit = true,
          agGridColumn.resizable = false,
          agGridColumn.cellStyle = function (params) {
            return {
              'font-size': '13px',
              'color': bookmarkColor,
              'overflow': 'visible',
              'margin-left': '8px',
              'padding': '10px',
              'padding-top': '14px',
              'height': '30px',
            };
          }
        break;
      case AG_GRID_ICONS.FOLDER_ICON:
        agGridColumn.pinned = 'right',
          //agGridColumn.suppressSizeToFit = true,
          agGridColumn.resizable = false,
          agGridColumn.cellRenderer = "buttonRenderer",
          agGridColumn.cellRendererParams = { isGridCompact: this.props.isGridCompact }
        agGridColumn.width = this.props.actionWidth,
          agGridColumn.cellStyle = function (params) {
            return {
              'bottom': '4px',
              'overflow': 'visible',
              'border-left': 'transparent',
              'border-right': `${isCellborder ? '1px solid #00000033' : ''}`,
            };
          }

        break;
      case AG_GRID_ICONS.OPEN_NEW_TAB_ICON:
        if (this.props.pageListId !== 'bre_summary_rpt') {
          agGridColumn.pinned = 'right',
            agGridColumn.suppressSizeToFit = true,
            agGridColumn.resizable = false,
            agGridColumn.cellRenderer = "openInNewTab",
            agGridColumn.width = counterpart.getLocale() == "SC" || counterpart.getLocale() == "TC" ? 130 : 100,
            agGridColumn.cellStyle = function (params) {
              if (acquirerCode == 'HPY') {
                return {
                  'color': '#3a3c44',
                  'overflow': 'visible',
                  'margin-left': '15px',
                  'padding-top': `${isGridCompact ? '0%' : '4%'}`,
                  'width': `${isGridCompact ? '20px' : '40px'}`,
                  'height': `${isGridCompact ? '20px' : '40px'}`,
                  'margin-top': `${isGridCompact ? '1%' : '2%'}`,
                  'border': `${isGridCompact ? 'none' : '1px solid #1362E2'}`,
                  'bottom': '7px',
                  'top': '1px',
                  'background-color': 'white',
                  'border-right': `${isCellborder ? '1px solid #00000033' : ''}`,
                  'padding-left': `${isGridCompact ? '2px' : '12px'}`,
                };

              } else {
                return {
                  'color': '#3a3c44',
                  'overflow': 'visible',
                  'margin-left': '15px',
                  'padding-top': `${isGridCompact ? '1%' : '4%'}`,
                  'width': `${isGridCompact ? '32px' : '40px'}`,
                  'height': `${isGridCompact ? '28px' : '40px'}`,
                  'margin-top': `${isGridCompact ? '3%' : '2%'}`,
                  'border': `${isCellborder ? `1px solid ${COLORS.oneGp.smoke}` : `1px solid ${COLORS.oneGp.smoke}`}`,
                  'bottom': '7px',
                  'top': '2px',
                  'background-color': 'white',
                  'padding-left': `${isGridCompact ? '6px' : '12px'}`,
                };
              }

            }

        }
        break;
      case AG_GRID_ICONS.OPEN_FOLDER_ICON:
        if (this.props.pageListId !== 'bre_summary_rpt') {
          agGridColumn.pinned = 'right',
            agGridColumn.suppressSizeToFit = true,
            agGridColumn.resizable = false,
            agGridColumn.cellRenderer = "openCase",
            agGridColumn.width = counterpart.getLocale() == "SC" || counterpart.getLocale() == "TC" ? 130 : 100,
            agGridColumn.cellStyle = function (params) {
              return {
                'color': '#3a3c44',
                'overflow': 'visible',
                'margin-left': '15px',
                'padding-top': `${isGridCompact ? '0%' : '4%'}`,
                'width': `${isGridCompact ? '20px' : '40px'}`,
                'height': `${isGridCompact ? '20px' : '40px'}`,
                'margin-top': `${isGridCompact ? '1%' : '2%'}`,
                'border': '1px solid #ddd',
                'bottom': `${isGridCompact ? '1px' : '7px'}`,
              };
            }
        }
        break;
        case AG_GRID_COLUMNS.MERCHANT_NUMBER:
          agGridColumn.cellRenderer = "merchantNumber";
          agGridColumn.cellClass = 'ag-cell--case-number';
          agGridColumn.cellStyle = function (params) {
            return {
            'padding-top': `${isGridCompact ? '0px' : '10px'}`,
            'border-right': `${isCellborder ? '1px solid #00000033' : ''}`,
            'color': COLORS.oneGp.black,
          };
      };
      break;
      case AG_GRID_ICONS.IMAGE_ICON:
        agGridColumn.pinned = 'right',
          agGridColumn.width = 70,
          agGridColumn.cellRenderer = "imageIcon",
          agGridColumn.suppressSizeToFit = true,
          agGridColumn.resizable = false,
          agGridColumn.cellStyle = function (params) {
            return {
              'padding-left': '12px',
              'border-left': 'transparent',
              'padding-top': `${isGridCompact ? '0px' : '4px'}`,
              'overflow': 'visible',
              'width': `${isGridCompact ? '25px' : ''}`,
              'margin-left': `${isGridCompact ? '25px' : ''}`,
            };
          }
        break;
      case AG_GRID_ICONS.TRASH_ICON:
        agGridColumn.pinned = 'right',
          agGridColumn.width = 60,
          agGridColumn.cellRenderer = "trashIcon",
          agGridColumn.suppressSizeToFit = true,
          agGridColumn.resizable = false,
          agGridColumn.cellStyle = function (params) {
            return {
              'overflow': 'visible',
              'bottom': '12px',
            };
          }
        break;
      default:
        agGridColumn.cellRenderer = "nonClickableComponents",
          agGridColumn.cellRendererParams = { isGridCompact: this.props.isGridCompact && false }
        agGridColumn.cellStyle = function (params) {
          return {
            'padding-top': `${isGridCompact ? '0px' : '5px'}`,
            'border-right': `${isCellborder ? '1px solid #00000033' : ''}`,
          };
        }
        break;
    }
    return agGridColumn;
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridApi.paginationGoToPage(this.state.currentPage);
    this.setState({
      isTableReady: true,
      isLoading: false
    });
    if (!this.state.isPagable) {
      const datastore = this.props.serverSideData(this.props, this);
      this.gridApi.setGridOption("serverSideDatasource", datastore);
    }
    if (this.props.isAutoHeight) {
      this.gridApi.setGridOption("domLayout", "autoHeight");
    }
  };

  onDrag = (e) => {
    const floatingPanel = document.getElementById('floating-panel');
    const queueLandingView = document.getElementById('queueManagementLanding');
    if (queueLandingView) {
      queueLandingView.style.opacity = `0.5`;
    }
    if (floatingPanel) {
      floatingPanel.style.display = `flex`;
      floatingPanel.style.top = `${e.pageY}px`;
      floatingPanel.style.left = `${e.pageX}px`;
    }
  };

  onDragStart = (e) => {
    const floatingPanel = document.getElementById('floating-panel');
    e.dataTransfer.setData('text/plain', '');
    const dragImg = new Image(0, 0);
    dragImg.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    e.dataTransfer.setDragImage(dragImg, 0, 0);
    if (floatingPanel) {
      floatingPanel.style.display = `flex`;
    }
  };

  onDragEnd = () => {
    const floatingPanel = document.getElementById('floating-panel');
    const queueLandingView = document.getElementById('queueManagementLanding');
    if (queueLandingView) {
      queueLandingView.style.opacity = `1`;
    }
    if (floatingPanel) {
      floatingPanel.style.display = `none`;
      floatingPanel.style.top = `0px`;
      floatingPanel.style.left = `0px`;
    }
  };

  onRowSelected = (event) => {
    const selected = event.node.data.caseStageId;
    this.setState({
      isDraggable: event.api.getSelectedNodes().length > 0 ? true : false
    })
    this.props.onCheckboxClick(selected);
  };

  onSelectionChanged = (event) => {
    var selectedRows = event.api.getSelectedNodes();
    if (this.state.rowData.length === selectedRows.length) {
      const data = selectedRows.map(row => { return row.data.caseStageId });
      this.props.onCheckboxClick(data)
    }
  };

  handleServerSideSort = (params) => {
    flushSync(() => {
      this.setState({
        isSortClicked: true,
        pageNumber: 0,
      });
    });
    document.addEventListener('click', (e) => {
      document.isControl = !!e.ctrlKey;
    });
    const newSortModel = params?.api?.getColumnState()
      ?.filter(ele => ele?.sort)
      ?.map(({ colId, sort }) => ({ key: colId, order: sort === 'asc' ? 1 : 0 }));
    const isSortModel = newSortModel?.length > 0;
    const columnName = isSortModel && newSortModel[0]?.key;
    const colId = columnName && columnName.split("_")[0] || "";
    const currentSortArr = getSortArray(this.state.gridSortArray, isSortModel, colId, document.isControl);
    if (isSortModel && !this.props.isLocalSort) {
      this.props.handleSort(colId, currentSortArr);
      this.setState({
        isLoading: true,
        gridSortArray: currentSortArr,
      });
    }
  };

  onDisplayedColumnsChanged = (params) => {
  };

  onFirstDataRendered = (params) => {
  };

  getContextMenuItems = (params) => {
    var result = params.value ? [
      {
        name: 'Copy',
        shortcut: 'Ctrl + C',
        action: function () {
          const dummy = document.createElement('textarea');
          document.body.appendChild(dummy);
          dummy.value = window.getSelection().toString();
          dummy.select();
          document.execCommand('copy');
          document.body.removeChild(dummy);
        },
      }
    ] : [];
    return result;
  };

  render() {
    return (
      <div
        className={`ag-theme-balham
        ${this.props.reportName == "Unresolved RTI"
            ? (this.props.isVisible ? "ag-grid-table-2" : "ag-grid-table-3")
            : (this.props?.isGridCompact ? ("ag-grid-table-compact" ? "ag-grid-table-compact-dyn " : "ag-grid-table") : "ag-grid-table")
          } 
      "ag-theme-balham-"+${this.state.acquirerCode[0]}`
        }
        onDragStart={(e) => this.onDragStart(e)}
        onDrag={(e) => this.onDrag(e)}
        onDragEnd={(e) => this.onDragEnd(e)}
        draggable={this.state.isDraggable}
        style={this.state.isPagable ? {} : this.props.isDataSearchTransaction === true ? { height: 'revert-layer' } : { height: 'calc(100vh - 250px)' }}
      >
        {this.state.isLoading ? <BVLoader20 /> :
          <AgGridReact
            animateRows={false}
            cacheBlockSize={this.state.cacheBlockSize}
            columnDefs={this.state.columnDefs}
            components={this.state.components}
            context={this.state.context}
            debug={false}
            defaultColDef={this.state.defaultColDef}
            enableCellTextSelection={true}
            enableHorizontalScrollbar={1}
            enableRangeSelection={false}
            enableVerticalScrollbar={1}
            getContextMenuItems={this.getContextMenuItems}
            icons={this.state.icons}
            isrelatedSearchLoaded={this.props.isrelatedSearchLoaded}
            modules={this.state.modules}
            onCloseClick={this.props.onCloseClick}
            onDisplayedColumnsChanged={this.onDisplayedColumnsChanged}
            onFirstDataRendered={this.onFirstDataRendered}
            onGridReady={this.onGridReady}
            onRowSelected={this.onRowSelected}
            onSelectionChanged={this.onSelectionChanged}
            onSortChanged={this.handleServerSideSort}
            pagination={this.state.isPagable}
            paginationPageSize={this.state.pageSize}
            resizable={this.state.resizable}
            rowData={this.state.rowData}
            rowHeight={this.state.rowHeight}
            rowModelType={this.state.rowModelType}
            rowSelection={this.state.rowSelection}
            sideBar={this.props.sideBar}
            suppressAnimationFrame={true}
            suppressCellFocus={true}
            suppressColumnVirtualisation={true}
            suppressNoRowsOverlay={true}
            suppressPaginationPanel={this.state.isPagable}
            suppressRowClickSelection={true}
            suppressRowTransform={true}
            tooltipShowDelay={this.state.tooltipShowDelay}
          />
        }
      </div>
    );
  }
}

AgGridTable.propTypes = {
  columnDefs: PropTypes.array,
  columnLazyDefs: PropTypes.array,
  defaultColDef: PropTypes.object,
  frameworkComponents: PropTypes.object,
  rowHeight: PropTypes.number,
  rowModelType: PropTypes.string,
  cacheBlockSize: PropTypes.number,
  maxBlocksInCache: PropTypes.number,
  isPagable: PropTypes.bool,
  rowData: PropTypes.array,
  totalRecords: PropTypes.number,
  recordsShown: PropTypes.number,
  currentPage: PropTypes.number,
  isNextPage: PropTypes.bool,
  paginationPageSize: PropTypes.number,
  paginationNumberFormatter: PropTypes.func,
  handleSort: PropTypes.func,
  isNewQueueLanding: PropTypes.bool,
  onCloseClick: PropTypes.bool,
  isGridCompact: PropTypes.bool,
  isCellborder: PropTypes.bool,
  isLocalSort: PropTypes.bool
};

AgGridTable.defaultProps = {
  columnDefs: [],
  defaultColDef: {
    checkbox: true,
    cellStyle: function (params) {
      return {
        "background-color": 'white', 'fontFamily': 'Roboto, sans-serif',
        'font-size': '13px',
        'color': '#3a3c44', 'overflow': 'visible'
      };
    },
    headerComponentParams: {
      menuIcon: 'fa-bars'
    },
    checkboxSelection: function (params) {
      var isGrouping = params.api.getRowGroupColumns().length > 0;
      return params.colIndex === 0 && !isGrouping;
    },
    resizable: true,
    cellDataType: false
  },
  cellRendererParams: { checkbox: true },
  columnLazyDefs: [],
  components: {
    tableHeaderCheckbox: AgGridCheckboxHeader,
    tableCheckbox: AgGridCheckbox,
    buttonRenderer: AgGridButton,
    bookmarkView: AgGridBookMark,
    openInNewTab: AgOpenInNewTab,
    openCase: AgFolderIcon,
    trashIcon: AgTrashIcon,
    imageIcon: AgImageIcon,
    nonClickableComponents: AgGridComponentWrapper,
    customTooltip: Customtooltip
  },
  rowHeight: 50,
  rowModelType: "serverSide",
  cacheBlockSize: 25,
  maxBlocksInCache: 10,
  isPagable: true,
  rowData: [],
  sort: [],
  totalRecords: 0,
  recordsShown: 0,
  currentPage: 1,
  isNextPage: true,
  paginationPageSize: 25,
  paginationNumberFormatter: function (params) {
    return "[" + params.value.toLocaleString() + "]";
  },
  suppressPaginationPanel: true,
  animateRows: false,
  suppressRowTransform: false,
  autoHeight: true,
  handleSort: () => { },
  actionWidth: 90,
  isNewQueueLanding: false,
  onCloseClick: false,
  isGridCompact: false,
  isCellborder: false,
  isLocalSort: false
};
export default AgGridTable;